import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../../services/api/api.service';

const name = 'DASHBOARD_PROFILE';

export const patchVendor = createAsyncThunk(`${name}/PATCH_VENDOR`,
  async ({vendorId, payload}, thunkApi) => {
    try {
      const response = await ApiService.patch(`/vendor/admin/${vendorId}`, {...payload});
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const uploadVendorPhoto = createAsyncThunk(`${name}/UPLOAD_VENDOR_PHOTO`,
  async ({vendorId, payload}, thunkApi) => {
    try {
      const response = await ApiService.post(`/vendor/admin/${vendorId}/add-photo`, payload, { headers: { 'content-type': 'multipart/form-data'}});
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const deleteVendorPhoto = createAsyncThunk(`${name}/DELETE_VENDOR_PHOTO`,
  async ({vendorId, photoId}, thunkApi) => {
    try {
      const response = await ApiService.delete(`/vendor/admin/${vendorId}/photo/${photoId}`);
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const setProfilePhoto = createAsyncThunk(`${name}/SET_PROFILE_PHOTO`,
    async ({vendorId, photoId}, thunkApi) => {
    try {
      const response = await ApiService.put(`/vendor/admin/${vendorId}/main-photo/${photoId}`, {vendor: vendorId, photoId: photoId});
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getCategories = createAsyncThunk(`${name}/GET_CATEGORIES`,
    async ({}, thunkApi) => {
      try {
        const response = await ApiService.get('/vendor/categories');
        let data = await response.data;
        if (response.status === 200) {
          return data;
        }
        return thunkApi.rejectWithValue(data);
      } catch (e) {
        return thunkApi.rejectWithValue(e);
      }
    });

const initialState = {
  vendor: undefined,
  categories: [],
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const dashboardProfileSlice = createSlice({
  name,
  initialState: initialState,
  extraReducers: {
    [patchVendor.fulfilled]: (state, { payload }) => {
      state.vendor = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [patchVendor.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [patchVendor.pending]: (state) => {
      state.isFetching = true;
    },
    [uploadVendorPhoto.fulfilled]: (state) => {
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [uploadVendorPhoto.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [uploadVendorPhoto.pending]: (state) => {
      state.isFetching = true;
    },
    [deleteVendorPhoto.fulfilled]: (state) => {
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [deleteVendorPhoto.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [deleteVendorPhoto.pending]: (state) => {
      state.isFetching = true;
    },
    [setProfilePhoto.fulfilled]: (state) => {
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [setProfilePhoto.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [setProfilePhoto.pending]: (state) => {
      state.isFetching = true;
    },
    [getCategories.fulfilled]: (state, { payload }) => {
      state.categories = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getCategories.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getCategories.pending]: (state) => {
      state.isFetching = true;
    },
  }
});
